<!-- colourConfig -->
<template>
  <div class="colourConfig">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="选择主题色：" size="zdy7" style="width:1000px; text-align: left" prop="colourConfig">
        <el-color-picker v-model="ruleForm.colourConfig" color-format="hex"></el-color-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'colourConfig',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
